module.exports = __webpack_public_path__ + "img/1168221980.224538ec.jpg";